export default __webpack_public_path__ + "static/media/11 - Midnight Electric.64bf7442.png";